import { useMountEffect } from '@/shared/hooks/useMountEffect';

interface FormReseedProps {
  /** Identity of the entity/mode the form is currently bound to. */
  reseedKey: string;
  /** Seeds the form for `reseedKey`. Runs post-commit, once per key. */
  onReseed: () => void;
}

const ReseedOnMount = ({ onReseed }: { onReseed: () => void }) => {
  useMountEffect(() => {
    onReseed();
    return undefined;
  });
  return null;
};

/**
 * Runs `onReseed` exactly once per distinct `reseedKey`, after commit.
 *
 * `react-hook-form`'s `reset()` synchronously notifies its subscribers, so
 * calling it from a panel's render body makes mounted `Controller`s call
 * setState while that panel is still rendering. Combining a `key`-driven
 * remount (Rule 5) with `useMountEffect` (Rule 4) keeps the reseed
 * post-commit without a `useEffect` in the panel.
 */
export const FormReseed = ({ reseedKey, onReseed }: FormReseedProps) => (
  <ReseedOnMount key={reseedKey} onReseed={onReseed} />
);
